import { useContext, useState } from 'react';
import _noop from 'lodash-es/noop';

import { getConfirmSaleStatus } from 'PrivateAPI';

import { DocumentCaptureConfirmationProgressContextType, DocumentCaptureOfferContext } from '../../containers/app/documentCapture/DocumentCaptureContexts';
import { RetrieveConfirmationSaleError } from '../../containers/app/documentCapture/DocumentCaptureError/RetrieveConfirmationSaleError';

type UseRetrieveConfimationSale = {
  onError?: (err: unknown) => void;
  onSuccess?: (data: DocumentCaptureConfirmationProgressContextType['progress']) => void;
}

export const useRetrieveConfirmationSale = ({
  onError = _noop,
  onSuccess = _noop,
}: UseRetrieveConfimationSale = {}) => {
  const context = useContext(DocumentCaptureOfferContext);
  const { valuation } = context;

  const enquiryId = valuation?.valuation_ref as string;
  const [loading, setLoading] = useState(false);

  const retrieveConfirmationSale = async () => {
    setLoading(true);

    try {
      const data = await getConfirmSaleStatus(parseInt(enquiryId));

      onSuccess(data);
    } catch (err: unknown) {
      onError(new RetrieveConfirmationSaleError(RetrieveConfirmationSaleError.getErrorMessage(err)));
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    retrieveConfirmationSale,
  };
};
